export default "__VITE_ASSET__PCl2vESm__"